import React from 'react';
import type { ClickHandler } from './usageMetricsLogger';

/**
 * React context that carries the page-level handleAndLogClick handler into
 * Take Action drawer content components.
 *
 * This avoids prop-drilling through the actionContent: React.FC interface
 * (which has no props by design) while still allowing drawer contents to log
 * clicks when a handler is available.
 *
 * Usage — provider (cellRenderers.tsx):
 *   <DrawerClickHandlerContext.Provider value={context.handleAndLogClick}>
 *     <ActionContent />
 *   </DrawerClickHandlerContext.Provider>
 *
 * Usage — consumer (CPI7.tsx, KpiFocusArea.tsx):
 *   const clickHandler = useDrawerClickHandler();
 *   clickHandler?.('Take Action Drawer - My Link', { url });
 */
export const DrawerClickHandlerContext = React.createContext<ClickHandler | undefined>(undefined);

/**
 * Hook to consume the DrawerClickHandlerContext.
 * Returns undefined when used outside a provider (AC4: no errors, normal navigation).
 */
export const useDrawerClickHandler = (): ClickHandler | undefined =>
  React.useContext(DrawerClickHandlerContext);
